import React from 'react';
import ImageComponent from 'atoms/Image';
import { ButtonComp } from 'atoms/Buttons';
import { getValueOrDefaultObject } from 'common/utilities/utils';
import { useHistory } from 'react-router-dom';

const KfcTimelineBanner = ({ data }) => {
  const { headline, ctaButton, noteLine, image } = getValueOrDefaultObject(data?.fields);
  const history = useHistory();
  return (
    <div className='kfc-timeline-banner container-fluid d-flex align-items-center justify-content-center'>
      <div className='row'>
        <div className='col-12 col-md-6 d-flex align-items-center flex-column justify-content-center mb-5 mb-md-0'>
          <span className='banner-heading text-center'>{headline}</span>
          <span className='learn-more-text text-center'>{noteLine}</span>
          {ctaButton && (
            <span className='text-center'>
              <ButtonComp
                className='button black-border redButton'
                onClick={() =>
                  ctaButton?.fields?.url
                    ? history.push(ctaButton?.fields?.url)
                    : window.open(ctaButton?.fields?.externalUrl, '_blank')
                }
                data-testid='company-history'
              >
                {ctaButton?.fields?.buttonText}
              </ButtonComp>
            </span>
          )}
        </div>
        <div className='col-12 col-md-6 d-flex text-center align-items-center justify-content-center'>
          <ImageComponent srcFile={image?.fields?.file?.url} />
        </div>
      </div>
    </div>
  );
};

export default KfcTimelineBanner;
